const tipos = [
    { label: 'Vertical', value: 'Vertical' },
    { label: 'Horizontal', value: 'Horizontal' },
    { label: 'Comercial', value: 'Comercial' },
];

const status = [
    { label: 'Ativo', value: 'Ativo' },
    { label: 'Futuro', value: 'Futuro' },
    { label: 'Lançado', value: 'Lançado' },
];

const camposTabela = [
    { label: 'Nome', value: 'name' },
    { label: 'Tipo', value: 'type' },
    { label: 'Retrofit', value: 'retrofit' },
    { label: 'Construtora', value: 'builder' },
    { label: 'Incorporadora', value: 'incorporator' },
    { label: 'Data de Lançamento', value: 'date_sale_start' },
    { label: 'Data de Entrega', value: 'date_delivery' },
    { label: 'Data Finalização de Vendas', value: 'date_sale_end' },
    { label: 'Data de Início Das Obras', value: 'date_work_start' },
    { label: 'Travar Localização', value: 'lock_location' },
    { label: 'Travar Torres', value: 'lock_towers' },
    { label: 'Travar Andares', value: 'lock_floors' },
    { label: 'Travar Elevadores', value: 'lock_elevator' },
    { label: 'Travar Banheiros', value: 'lock_qty_bathrooms' },
    { label: 'CEP', value: 'zipcode' },
    { label: 'Endereço', value: 'address' },
    { label: 'Número', value: 'number' },
    { label: 'Bairro', value: 'neighborhood' },
    { label: 'Cidade', value: 'city' },
    { label: 'Estado', value: 'state' },
    { label: 'Complemento', value: 'complement' },
    { label: 'Longitude', value: 'longitude' },
    { label: 'Latitude', value: 'latitude' },
    { label: 'Telefone de Vendas', value: 'telefone_vendas' },
    { label: 'Site', value: 'site' },
    { label: 'Tipo de Mapeamento', value: 'mapeamento_worker' },
    { label: 'Informações Adicionais de Contato', value: 'contact_info' },
    { label: 'Elevadores', value: 'elevator' },
    { label: 'Total de Unidades do Empreendimento', value: 'total_units' },
    { label: 'Possui Suites', value: 'has_suites' },

    { label: 'Período', value: 'period' },
    { label: 'Andares', value: 'floors' },
    { label: 'Número de Torres', value: 'towers' },
    { label: 'Status', value: 'status' },
    { label: 'Soma Unidades por Tipologia', value: 'qty_units' },
    { label: 'Tipologias com 1 Quarto', value: 'qty_1_bedroom' },
    { label: 'Tipologias com 2 Quartos', value: 'qty_2_bedroom' },
    { label: 'Tipologias com 3 Quartos', value: 'qty_3_bedroom' },
    { label: 'Tipologias com 4 Quartos', value: 'qty_4_bedroom' },
    { label: 'Tipologias com 1 Quarto Cobertura/Garden', value: 'qty_1_bedroom_roof' },
    { label: 'Tipologias com 2 Quartos Cobertura/Garden', value: 'qty_2_bedroom_roof' },
    { label: 'Tipologias com 3 Quartos Cobertura/Garden', value: 'qty_3_bedroom_roof' },
    { label: 'Tipologias com 4 Quartos Cobertura/Garden', value: 'qty_4_bedroom_roof' },
    { label: 'Tipologias Studio', value: 'qty_studio' },
    { label: 'Tipologias Studio Cobertura/Garden', value: 'qty_studio_roof' },

    { label: 'Quantidade de Unidades', value: 'qty' },
    { label: 'Área Privada', value: 'private_area' },
    { label: 'Área Total', value: 'public_area' },
    { label: 'Quantidade de quartos', value: 'number_bedroom' },
    { label: 'Suítes', value: 'qty_suites' },
    { label: 'Vagas de Garagem', value: 'garage' },
    { label: 'Tipologia', value: 'type_of_typology' },
    { label: 'Preço de Lançamento', value: 'release_price' },

    { label: 'Valor Negociado', value: 'price_negotiated' },
    { label: 'Venda no Período', value: 'sold_in_period' },
    { label: 'Distratos', value: 'distractions' },
];

export { tipos, status, camposTabela };